<template>
  <div class="container info-container" style="touch-action: auto;">
    <h1>About the Project</h1>
    <h2>🚀 Be Part of XRP History – Pixel by Pixel!</h2>
    <p>
      Launched in 2021, the <b>Million Pixel XRP Wall</b> is more than just a wall — it’s a living monument to the <b>XRP community’s energy, passion, and legendary grind</b>. Whether you’re an OG or just joining the ride, this is your chance to lock in your place in the XRPL timeline.
      <br><br>
      This one-of-a-kind digital wall is made up of <b>1 million pixels</b> (yup, a literal million!), where individuals, projects, brands, and memes carve out their own square in crypto history. Got a logo? A GIF? A message? An inside joke? Let the blockchain remember it.
    </p>

    <h2>🔥 Why It’s So Epic</h2>
    <p>
      This isn’t just a wall…<br>
      It’s where <b>XRP legends gather</b>, where memes become monuments, and where pixel blocks turn into community symbols.
      <br><br>
      ✅ Post your picture<br>
      ✅ Link to your X page, project, or collection<br>
      ✅ Flex your GIFs<br>
      ✅ And become part of something BIG<br><br>
      Whether it’s a bear market or bull run — your space on the wall is eternal.
    </p>

    <h2>💥 Power to the Pixel Holders</h2>
    <p>
      Once you grab a spot, you’re not just locked in — you’re <b>part of a community movement</b>. Pixel holders get access to airdrops, giveaways, collabs, and sneak peeks from XRPL’s most exciting projects.
      <br><br>
      🔥 Collabs with XRPL projects<br>
      🧱 The wall is also fueling the ecosystem through $XBANK buybacks and burns<br>
      💸 Every purchase adds real value to the project and holders
    </p>

    <h2>🛒 Easy Buy with Xaman Wallet</h2>
    <p>
      Joining is super easy:<br>
      Log in with your <b>Xaman wallet</b>, choose your pixel location, upload your image or GIF, and you’re on the blockchain in seconds. Your spot is visible instantly in your profile — and <b>your wallet address becomes the official owner</b>.
      <br><br>
      Want to change your image later? You can do that too! Just log in and update it anytime for a small fee.
    </p>

    <h2>💎 Legendary Spots & Future Upgrades</h2>
    <p>
      Want to be immortalized next to <b>David Schwartz</b> or <b>Brad Garlinghouse?</b><br>
      Yep — we’ve got <b>exclusive central spots</b> up for grabs. DM us to talk legendary placement. These premium locations also help fuel the $XBANK buy & burn engine.
    </p>

    <h2>🌍 Together, We Pixel</h2>
    <p>
      The Million Pixel XRP Wall isn’t just a canvas — it’s a crypto monument, a digital time capsule, and a tribute to everyone who believes in the future of XRPL.
      <br><br>
      <b>Claim your place. Join the movement. Make history.</b>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
</style>
